export default "__VITE_ASSET__DgzSj7oK__"